import { TableFilters, TableSort } from '../../redux/Tables/filtersKeys';

export type QueryParamGeneratorProps = {
  pageNumber?: number;
  filters?: TableFilters;
  sort?: TableSort | null;
  selectAll?: boolean;
  selectedIds?: string[];
  isInvoice?: boolean;
};

export const EXCLUDED_IDENTIFIER_PROPERTY = 'excludedId';
export const SELECTED_IDENTIFIER_PROPERTY = 'selectedId';

export interface ApiFilterQueryParamGeneratorInterface {
  format: (queryParamGeneratorProps: QueryParamGeneratorProps) => string;
  formatQueryParamForSelectAllAndSelectedIds: (
    selectAll: boolean | undefined,
    selectedIds: string[],
  ) => string;
}
